<template>
  <div class="grid grid-cols-2 gap-1.5 px-2 lg:gap-10">
    <CMSLink
      v-for="(topMetaBarLink, index) in filteredBlok"
      :key="topMetaBarLink._uid"
      class="text-sm font-normal leading-4 text-black lg:text-black-80"
      :cms-link="topMetaBarLink.link"
      :open-new-tab="openNewTab(topMetaBarLink)"
      data-test-id="top-meta-bar-link"
      @click="trackEvent(index)"
      >{{ topMetaBarLink.label }}
    </CMSLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
import type {
  SbNavigation,
  SbTopMetaBarLabel,
} from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  blok: {
    type: Array as PropType<SbNavigation['TopMetaBar']>,
    default: () => [],
  },
})

const emit = defineEmits(['click:link'])

const filteredBlok = computed(
  () => props.blok?.filter(({ link, label }) => link && label) ?? [],
)

const trackEvent = (index: number) => {
  const item = filteredBlok.value[index]
  if (!item) {
    return
  }
  emit('click:link', item.link.cached_url)
}

const openNewTab = (label: SbTopMetaBarLabel) =>
  label.link.cached_url?.includes('http://') ||
  label.link.cached_url?.includes('https://')
</script>
